/**
 * engagementactions.js.js
 * Created by calhosh on 8/27/2020.
 */
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';
import * as types from '../actiontypes';
import {promiseAreas} from '../../util/uiconstants';

export function getEngagement(url) {
	return {
		type: types.GET_ENGAGEMENT,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getClientEngagements(url, body, payload) {
	return {
		type: types.GET_CLIENT_ENGAGEMENTS,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: body
			}
		},
		payload
	};
}

export function clearClientEngagements(payload) {
	return {
		type: types.CLEAR_CLIENT_ENGAGEMENTS,
		payload
	};
}

export function getAllUserEngagements(url) {
	return {
		type: types.GET_ALL_USER_ENGAGEMENTS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementMetaData(projectId, userType) {
	let url = env.getOversightBaseURL(serviceURL, projectId) + 'engagements';
	return {
		type: types.LOAD_ENGAGEMENTMETADATA,
		userType,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
}

export function getEngagementUsersWithRoles(url) {
	return {
		type: types.GET_ENGAGEMENT_USERS_WITHROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.USERROLE_SELECTION_AREA
			}
		}
	};
}

export function getCountryStatus(url, resource) {
	return {
		type: types.GET_COUNTRY_STATUS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getEngagementRoles(url, resource) {
	return {
		type: types.GET_ALL_ENGAGEMENT_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getRbacRoles(url, resource) {
	return {
		type: types.GET_ALL_RBAC_USER_ROLES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

export function getWorkspaceDetails(url) {
	return {
		type: types.GET_WORKSPACE_METADATA,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}
